<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article class="grid gap-4 md:w-80 md:mx-auto justify-center">
        <img
          src="../assets/gPayPending.svg"
          alt="Pending"
          class="justify-self-center pt-4"
        />
        <div class="grid gap-5 text-center pt-4">
          <p class="text-3xl font-blogger font-bold text-headingColor width17rem">eMandate registration pending</p>
          <p v-if="queryData.pendingMessage" class="text-center text-headingColor font-myriad text-base width17rem">
            {{ queryData.pendingMessage }}
          </p>
        </div>
      </article>
    </section>
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import overLayGoBack from '../components/overLayGoBack.vue';

export default {
  name: 'MandatePending',
  components: { overLayGoBack },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    setTimeout(() => {
      this.isOverLay = true;
    }, 4000);
  },
  data() {
    return {
      isOverLay: undefined,
      queryData: this.$route.query,
    };
  },
  methods: {
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  }
};
</script>
